import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PutCartItem')
export default class PutCartItem {
  constructor() {
    this.cartCode = undefined;
    this.goodsId = undefined;
    this.goodsCode = undefined;
    this.quantity = 1;
    this.goodsOptionIds = [];
  }

  @JsonProperty('cart_code')
  public cartCode?: string;

  @JsonProperty('goods_id', null, true)
  public goodsId?: number;

  @JsonProperty('goods_code', null, true)
  public goodsCode?: string;

  @JsonProperty('quantity')
  public quantity: number;

  @JsonProperty('goods_option_ids', [Number], true)
  public goodsOptionIds: number[];
}
